// extracted by mini-css-extract-plugin
module.exports = {"card":"PricingSection_card__ztimT","iconContainer":"PricingSection_iconContainer__PZ70W","logo":"PricingSection_logo__fBwxL"};